import React from 'react';

function MorienterForm() {
  return (
    <div>
      <h1>Formulaire d’aide à l’orientation</h1>
      <iframe
        src="/formulaire/pa.html"
        title="Formulaire PA"
        width="100%"
        height="800px"
        style={{ border: 'none' }}
      />
    </div>
  );
}

export default MorienterForm;
